import {authHeader} from "../../../helpers/authHeader";
import axios from 'axios';


export default {
    init,
    find,
    update,
    loadStockTakingsInProgress,
    saveStockTaking
};


function find(code, stock_taking_id) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/inventory/stockTaking/find/' + stock_taking_id + '/' + code, requestOptions )
        .then((response) => {
            return response.data.data;
        }, handleError);
}

function saveStockTaking(stock_taking_id) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/inventory/stockTaking/save/' + stock_taking_id , requestOptions )
        .then(() => {
            return true;
        }, handleError);
    
}

function loadStockTakingsInProgress(account_id) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/inventory/stockTaking/inProgress/' + account_id , requestOptions )
        .then((response) => {
            return response.data.data;
        }, handleError);
}

function update(stock_taking_id,id,count,counted,comment) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    const fields = {
        count,counted,comment
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/inventory/stockTaking/' + stock_taking_id + '/' + id, fields, requestOptions )
        .then((response) => {
            return response.data.data;
        }, handleError);
}


function init(account_id,stock_taking_id) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/inventory/stockTaking/' + account_id + '/' + stock_taking_id, requestOptions )
        .then((response) => {
            return response.data.data;
        }, handleError);
}


function handleError(error) {

    if (error.response && !(error.response.status >= 200 && error.response.status < 300)) {
        return Promise.reject(error.response.status);
    }

    return Promise.reject(500);

}



// WEBPACK FOOTER //
// ./src/scenes/Inventory/reducer/api.js